import { genericTaxFormType, } from 'complexComponents/taxes/TaxFormRenderer/TaxFormRenderer.models';
export const isEligibleForCertificationTypeSelect = (formType, isIndividual, isSignatureAllowed) => {
    if (!isSignatureAllowed) {
        return false;
    }
    if (formType === genericTaxFormType.Enum.W9) {
        return true;
    }
    return isIndividual;
};
